<template>
    <div class="documententry-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Pesquisa de Documento de Entrada"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    @click="actionNewDocumentEntry"
                    variant="dark"
                    class="mr-2 mt-2 fa fa-plus"
                >
                </b-button>
                <b-button
                    size="sm"
                    class=" mt-2 fa"
                    :class="icon"
                    @click=";[loadDocumentEntrys(), (showTable = !showTable)]"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="documententry-search-start_date"
                >
                    <b-form-input
                        id="documententry-search-start_date"
                        type="date"
                        v-model="start_date"
                        v-on:keyup.enter="loadDocumentEntrys"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="documententry-search-end_date"
                >
                    <b-form-input
                        id="documententry-search-end_date"
                        type="date"
                        v-model="end_date"
                        v-on:keyup.enter="loadDocumentEntrys"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="documententry-search-company_id"
                >
                    <b-form-select
                        id="documententry-search-company_id"
                        @input="loadDocumentEntrys"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Status:"
                    label-for="documententry-search-document_status_id"
                >
                    <b-form-select
                        id="documententry-search-document_status_id"
                        size="sm"
                        @input="loadDocumentEntrys"
                        :options="documentstatus"
                        v-model="document_status_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="entity-id">
                    <b-form-input
                        id="entity-id"
                        type="text"
                        v-model="entity_id"
                        @input=";[setEntity(), loadDocumentEntrys()]"
                        v-on:keyup.enter="openModalEntity"
                        size="sm"
                        placeholder="Código..."
                    />
                </b-form-group>
            </b-col>
            <b-link
                v-b-modal.modalEntity
                @click="showEntity = true"
                class="fa fa-search mt-4"
            ></b-link>
            <b-col md="4" sm="8">
                <b-form-group label="Nome:" label-for="entity-name_entity">
                    <b-form-input
                        id="entity-name_entity"
                        type="text"
                        v-model="entity.name_entity"
                        size="sm"
                        :readonly="true"
                        placeholder="Nome..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                    <b-form-input
                        id="entity-cnpj_cpf"
                        type="text"
                        v-model="entity.cnpj_cpf"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>
            <b-link v-b-modal.modalRegisterEntity class="fa fa-plus mt-4">
            </b-link>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <hr />
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            striped
                            :items="documententrys"
                            :fields="fieldsDocumentEntry"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Editar registro"
                                    size="sm"
                                    variant="light"
                                    @click="actionEditDocumentEntry(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
              
                                <b-button
                                    title="Excluir registro"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.document_status_id === 6 ||
                                            data.item.document_status_id === 1
                                    "
                                    @click="showMsgBoxCancel(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-trash"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalEntity"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="6" sm="8">
                        <b-form-group
                            label="Nome:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ/Banco/Caixa:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="control-label">
                                <i class="fa fa-search"></i> Pesquisar
                            </label>
                            <b-button
                                size="sm"
                                class=" ml-2 mb-2 fa fa-search"
                                @click=";[loadEntitys()]"
                                variant="outline-secondary"
                            ></b-button>
                            <b-form-select
                                id="accountingentry-search-type_entity_id"
                                @input=";[loadEntitys(), (showEntity = true)]"
                                size="sm"
                                class="mb-2"
                                :options="typeentitys"
                                v-model="type_entity_id"
                            />
                            <input
                                type="text"
                                icon="search"
                                v-model="searchEntity"
                                placeholder="Informe o nome/CPF-CNPJ"
                                class="form-control"
                            />
                        </div>
                    </div>
                </b-row>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    v-show="showEntity"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredListEntity"
                    :fields="fieldsEntity"
                >
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="Selecionar o registro"
                            size="sm"
                            variant="secondary"
                            @click="
                                ;[
                                    setSearchEntity(data.item),
                                    (showEntity = !showEntity),
                                    hideModal(),
                                ]
                            "
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rowsEntity"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-form>
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
var moment = require('moment')

export default {
    name: 'DocumentEntrySearch',
    components: { PageTitle, EntityModal },
    data: function() {
        return {
            mode: 'insert',
            modeDocumentEntry: 'insert',
            start_date: null,
            end_date: null,
            document_status_id: null,
            company_id: null,
            entity_id: null,
            type_entity_id: null,
            search: '',
            searchsetparms: {},
            searchEntity: '',
            documententry: {},
            documententrys: [],
            documentstatus: [],
            entity: {},
            entitys: [],
            companys: [],
            typeentitys: [],
            entitysshearch: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showDocumentEntry: false,
            showEntity: false,
            perPage: 5,
            currentPage: 1,
            fieldsDocumentEntry: [
                { key: 'id', label: 'ID', sortable: true },
                {
                    key: 'issue_date',
                    label: 'Data Emissão',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : '',
                },
                {
                    key: 'name_entity',
                    label: 'Nome',
                    sortable: true,
                    variant: 'secondary',
                },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: true },
                { key: 'name_reduced', label: 'Tipo Doc.', sortable: false },
                { key: 'document_number', label: 'Nº.', sortable: false },
                { key: 'document_value', label: 'Valor', sortable: false },
                {
                    key: 'name_operation_level_two',
                    label: 'Operação',
                    sortable: false,
                },
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false,
                    variant: 'secondary',
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.documententrys.length
        },
        rowsEntity() {
            return this.entitysshearch.length
        },
    },
    methods: {
        showMsgBoxCancel(docentry) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.removeDocumentEntry(docentry)
                    }
                })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        async loadEntitys() {
            if (this.compan.id) {
                const url = `${baseApiUrl}/entitysallcompany/${this.compan.id}/?type_entity_id=${this.type_entity_id}`
                await axios.get(url).then(res => {
                    this.entitysshearch = res.data
                })
            } else {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            }
        },
        async loadDocumentEntrys() {
            if (this.document_status_id) {
                const url = `${baseApiUrl}/documententryssearchdatestatus/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.document_status_id}&entity_id=${this.entity_id}`
                await axios.get(url).then(res => {
                    this.documententrys = res.data
                })
            } else {
                const url = `${baseApiUrl}/documententryssearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_id=${this.entity_id}`
                await axios.get(url).then(res => {
                    this.documententrys = res.data
                })
            }
        },
        async confirmDocumentEntry(documententry) {
            if (documententry.id) {
                await axios
                    .get(`${baseApiUrl}/documententrys/${documententry.id}`)
                    .then(res => (this.documententry = res.data))
                    .catch(showError)

                this.documententry.user_update_id = this.user.id
                this.documententry.update_date = this.formatDate(Date())
                if (this.documententry.document_status_id === 1) {
                    this.documententry.document_status_id = 2
                } else if (this.documententry.document_status_id === 2) {
                    this.documententry.document_status_id = 1
                }
                const method = 'put'
                const id = `/${documententry.id}`
                await axios[method](
                    `${baseApiUrl}/documententrys${id}`,
                    this.documententry
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadDocumentEntrys()
                    })
                    .catch(showError)
            }
        },
        async canceledDocumentEntry(documententry) {
            this.documententry = { ...documententry }

            if (this.documententry.id) {
                this.documententry.user_canceled_id = this.user.id
                this.documententry.canceled_date = this.formatDate(Date())

                this.documententry.document_status_id = 5

                const method = this.documententry.id ? 'put' : 'post'
                const id = this.documententry.id
                    ? `/${this.documententry.id}`
                    : ''
                await axios[method](
                    `${baseApiUrl}/documententrys${id}`,
                    this.documententry
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadDocumentEntrys()
                    })
                    .catch(showError)
            }
        },

        async removeDocumentEntry(documententry) {
            const id = documententry.id
            await axios
                .delete(`${baseApiUrl}/documententrys/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadDocumentEntrys()
                })
                .catch(showError)
        },
        async setEntity() {
            const url = `${baseApiUrl}/entitys/${this.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        actionEditDocumentEntry(documententry) {
            if (documententry.issue_date)
                documententry.issue_date = this.formatDate(
                    documententry.issue_date
                )
            if (documententry.documententry_date)
                documententry.documententry_date = this.formatDate(
                    documententry.documententry_date
                )

            this.$router.push({
                name: 'RecordDocumentEntry',
                params: { id: documententry.id },
                query: { documententrybase: documententry },
            })
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status,
                    }
                })
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        actionNewDocumentEntry() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                const documententry = {}
                documententry.document_status_id = 1
                documententry.operation_id = 1
                documententry.checkvalueplot = 0
                this.$router.push({
                    name: 'RecordDocumentEntry',
                    query: { documententrybase: documententry },
                    //params: {id: documententry.id}
                })
            }
        },
        async loadTypeEntitys() {
            const url = `${baseApiUrl}/typeentitysall`
            await axios.get(url).then(res => {
                this.typeentitys = res.data.map(typeentity => {
                    return { value: typeentity.id, text: typeentity.name }
                })
            })
        },
        setSearchEntity(entity) {
            this.entity_id = entity.id
            this.entity = { ...entity }
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
    },
    mounted() {
        if (!this.compan) {
            this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
        } else {
            this.start_date = moment()
                .startOf('month')
                .format('YYYY-MM-DD')
            this.end_date = moment()
                .endOf('month')
                .format('YYYY-MM-DD')
            this.company_id = this.compan.id
            this.loadCompanys()
            this.loadTypeEntitys()
            this.loadDocumentStaus()
            this.loadDocumentEntrys()
            this.showTable = true
        }
    },
}
</script>

<style>
.documententry-search {
    font-size: 0.7rem;
}

.documententry-search input,
label,
form {
    font-size: 0.7rem;
}
.documententry-search button {
    font-size: 0.7rem;
}

.documententry-search select {
    font-size: 0.7rem;
}

.documententry-search table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
